import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { verticalTypesEnum } from '../enums/vertical-types.enum';

/**
 * Returns prioritized games than only present on current GGL
 */
export const useFilteredPrioritizedGames = (verticalCode = verticalTypesEnum.CASINO) => {
    const { prioritizedGames, gamesById } = useSelector((state) => (state.casino));
    const [presentGamesOnBrand, setPresentGamesOnBrand] = useState([]);

    useEffect(() => {
        if (gamesById && prioritizedGames && prioritizedGames[verticalCode]) {
            const gameIds = Object.keys(gamesById);
            const gamesFiltered = [];

            prioritizedGames[verticalCode].forEach((prioritizedGame) => {
                if (gameIds.includes(prioritizedGame.id)) {
                    gamesFiltered.push(prioritizedGame.id);
                }
            });

            setPresentGamesOnBrand(gamesFiltered);
        }
    }, [prioritizedGames, gamesById]);

    return {
        presentPrioritizedGamesOnBrand: presentGamesOnBrand
    };
};
